<template>
  <div>
    <el-card shadow="nerver">
      <el-breadcrumb separator="/">
        <!-- separator 分隔符 -->
        <el-breadcrumb-item :to="{ name: 'traver_guide_config' }">返回</el-breadcrumb-item>
        <el-breadcrumb-item>新建行前手册</el-breadcrumb-item>
      </el-breadcrumb>
    </el-card>
    <!-- 添加和新建 -->
    <el-card class="add_poi_form"
             v-loading='loading'
             shadow="never">
      <div style="display:flex;margin-bottom:20px">
        <!-- 目的地 -->
        <div>
          <select-dest placeholder="所属目的地"
                       @selectDest="selectDest"></select-dest>
        </div>
        <!-- 搜索 -->
        <el-input size="mini"
                  style="width:20%;margin-left:20px"
                  placeholder="请输入搜索内容"
                  v-model="searchContentKeyword"
                  clearable>
          <el-button slot="append"
                     @click="searchButton"
                     icon="el-icon-search"></el-button>
        </el-input>
      </div>
      <!-- 已选内容 -->
      <div v-if="check_content_list.length !== 0"
           class="check_content_list_area">
        <div v-for="item in check_content_list"
             :key="item.id">
          <span style="margin-bottom:5px;
                      padding:5px;
                      font-size:10px;
                      display: inline-block;
                      border:1px solid #ff5421;
                      border-radius:10px">
            {{item.title}}
            <i style="cursor:pointer;color:#FF5421"
               @click="removeContent(item)"
               class="el-icon-circle-close"></i>
          </span>
        </div>
        <div style="margin-bottom: 10px">
          <el-input type="textarea"
                    :autosize="{ minRows: 2, maxRows: 4}"
                    placeholder="请输入清单说明"
                    v-model="before_trip_info">
          </el-input>
        </div>
        <el-button size="mini"
                   style="margin:auto"
                   type="primary"
                   @click="createdBeforeTrip()">新建行前手册</el-button>
      </div>
      <!-- 内容列表：可选 -->
      <el-table ref="multipleTable"
                :data="content_list"
                tooltip-effect="dark"
                row-key="id"
                style="width: 100%"
                @select="handleSelectionChange">
        <el-table-column type="selection"
                         :reserve-selection="true"
                         width="55">
        </el-table-column>
        <!-- 封面 -->
        <el-table-column label="内容"
                         width="120">
          <template slot-scope="scope">

            <el-image :src="scope.row.image"
                      fit="fill"></el-image>
          </template>
        </el-table-column>
        <el-table-column label=""
                         width="">
          <template slot-scope="scope">{{ scope.row.title }}</template>
        </el-table-column>
        <el-table-column prop="corner_name"
                         label="目的地"
                         width="120">
        </el-table-column>
        <el-table-column prop="update_time"
                         label="更新日期"
                         show-overflow-tooltip>
        </el-table-column>
      </el-table>
      <!-- ----------------- 分页 ------------------ -->
      <div class="pagination">
        <el-pagination @current-change="handleCurrentChange_system"
                       :small="true"
                       background
                       layout="prev, pager, next,total"
                       :current-page.sync="pagenum_system"
                       :page-size="pagesize"
                       :total="page_account"></el-pagination>
      </div>
      <!-- 表格结束 -->
    </el-card>
  </div>
</template>

<script>
import SelectDest from '../../components/common/select/SelectDest'

export default {
  name: 'before_trip_list_add',
  components: {
    'select-dest': SelectDest,
  },
  data() {
    return {
      loading: false,
      searchContentKeyword: '',
      tag_list: '',
      dest: '',
      pagenum_system: 1, // 当前页
      pagesize: 12, // 每页容量，自行设定
      page_account: null,
      // 全部信息
      content_list: [],
      // 选择的条目 ji 类别
      check_content_list: [],
      before_trip_id: '',
      before_trip_info: '',
      postCheckItem: {},
      tableData: [],
      remark: '',
    }
  },
  created() {
    this.before_trip_id = this.$route.query.before_trip_id
    this.$http
      .get(
        `/traver/get_before_trip_content?before_trip_id=${this.$route.query.before_trip_id}`
      )
      .then((res) => {
        if (res.data.errno == '0') {
          res.data.data.forEach((i) => {
            // console.log(i)
            let item = {
              id: i.id,
              title: i.content_title,
              title_mini: i.content_introduce,
              image: i.content_cover,
              corner_name: i.dest,
              tag: i.tag,
              update_time: i.update_time,
              type: i.content_class,
            }
            this.check_content_list.push(item)
          })
        }
      })
    // 先通过ID 获取 包含哪些内容
  },
  mounted() {
    this.getContentList()
  },
  methods: {
    // 选择目的地
    selectDest(value) {
      this.dest = value
    },
    searchButton() {
      this.getContentList()
    },
    handleCurrentChange_system(page) {
      this.content_list = []
      this.pagenum_system = page
      this.getContentList()
    },
    handleSelectionChange(val, row) {
      let cleck_item = this.check_content_list.indexOf(row)
      if (cleck_item == -1) {
        this.check_content_list.push(row)
      } else {
        this.check_content_list.splice(cleck_item, 1)
      }
    },
    // 移除选中
    removeContent(val) {
      this.content_list.forEach((i) => {
        if (i.id == val.id) {
          console.log(i)
          this.check_content_list.splice(this.check_content_list.indexOf(i), 1)
          this.$refs.multipleTable.toggleRowSelection(i, false)
        }
      })
    },
    // 获取内容
    getContentList() {
      this.loading = true
      this.$http
        .get(
          `/traver/get_content_list?title=${this.searchContentKeyword}&dest=${this.dest}&tag=${this.tag_list}&p_num=${this.pagenum_system}&p_size=${this.pagesize}`
        )
        .then((res) => {
          this.page_account = res.data.item_account
          if (res.data.errno == '0') {
            let list = res.data.content
            list.forEach((i) => {
              let item = {
                id: i.id,
                title: i.title,
                title_mini: i.introduce,
                image: i.cover_image,
                corner_name: i.dest,
                tag: i.tag,
                update_time: i.update_time,
                type: i.type,
              }
              this.content_list.push(item)
            })
            // 已有id内容进行勾选
            this.check_content_list.forEach((content) => {
              this.content_list.forEach((i) => {
                if (i.id == content.id) {
                  this.$refs.multipleTable.toggleRowSelection(i, true)
                }
              })
            })
            this.loading = false
          }
        })
    },

    createdBeforeTrip() {
      this.$prompt('请输入手册名称', '创建行前手册', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
      })
        .then(({ value }) => {
          // 发送请求
          let before_trip_post = {
            before_trip_id: this.before_trip_id,
            content_list: this.check_content_list,
            before_trip_title: value,
            before_trip_info: this.before_trip_info,
          }
          this.$http
            .post(`/traver/updated_before_trip_list`, before_trip_post)
            .then((res) => {
              console.log(res)
              if (res.data.errno == '0') {
                this.$message({
                  type: 'success',
                  message: res.data.errmsg,
                })
                this.$router.push('/traver_guide_config')
              } else {
                this.$message({
                  type: 'error',
                  message: res.data.errmsg,
                })
              }
            })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '取消创建',
          })
        })
    },
  },
}
</script>


<style>
.check_content_list_area {
  background-color: #ffbeaa;
  /* text-align: center; */
  padding: 10px;
  font-size: 15px;
  border-radius: 10px;
}
.el-table__header-wrapper .el-checkbox {
  display: none;
}
</style>